import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'manage-acuite-visuelle',
    components: {
        VueEditor
    },
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_user: Object,
        group_id: Number,
        grs_toggler: Number,
        selected_acuite: Array,
        data_to_be_deleted: Object
    },
    data() {
        return {
            save_loading: false,
            is_loading: true,
            acuite_data: {
                v_model: []
            },
            fields: [
                'od_sc', 'od_ts', 'od_ac',
                'og_sc', 'og_ts', 'og_ac',
                'interpretation'
            ],

            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,
            customToolbar: vueEditorToolbar,
        }
    },

    watch : {
        grs_toggler() {
            this.initFields()
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        initFields() {
            this.is_loading = true
            this.acuite_data = {
                v_model: []
            }
            
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.selected_acuite.length > 0) {
                    v = this.selected_acuite[index]['field_content']
                } 
                
                this.acuite_data.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        saveAcuiteVisuelle() {
            this.permission_is_denied = false
            this.is_error = false

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: this.info_user,
                data_type: 'acuite_visuelle',
                champs: this.acuite_data.v_model
            }
            this.save_loading = true

            store_fiche.saveConsultationFicheSectionData(data).then((response) => {
                if (response.success) {
                    this.$refs.mdl_acv.click()
                    this.$emit('emitRefreshAcuiteVisuelle')
                    this.successToast(response.message)

                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.mdl_acv.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerAV(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('deleteAntecedent', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès !')
                    this.$emit("emitRefreshAcuiteVisuelle")

                    this.$refs.del_grp_acv.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        }
    }
}